import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import classNames from 'classnames';
import { universalStyles, white } from '../../../../app/theme';

const useStyles = makeStyles(() => ({
  ...universalStyles,
  heading: {
    marginTop: 24,
  },
  text: {
    color: white,
  },
}));

const AcquisitionPage04 = (): JSX.Element => {
  const classes = useStyles();

  return (
    <>
      <Typography variant="h6" className={classes.heading}>
        Purpose
      </Typography>
      <Typography className={classes.text}>
        There are several considerations for acquiring the best quality images with Axumin. In this training, you will
        explore these considerations at each step of the image acquisition process.
      </Typography>
      <Typography variant="h6" className={classes.heading}>
        Objectives of this section include:
      </Typography>
      <ul className={classNames(classes.list, classes.text)}>
        <li>Identify the steps needed to effectively capture optimal quality images</li>
        <li>
          Identify the key recommendations for dosing, administration, patient preparation, image acquisition, and image
          reconstruction
        </li>
      </ul>
      <Typography variant="h6" className={classes.heading}>
        Note that the following resources are available in the Downloadable Resources section:
      </Typography>
      <ol className={classNames(classes.list, classes.orderedList, classes.text)}>
        <li>Axumin PET/CT Prostate Patient Questionnaire</li>
        <li>Axumin Injection Acquisition Criteria Card</li>
      </ol>
      <Typography variant="h6" className={classes.heading}>
        Explore each step to learn more about image acquisition:
      </Typography>
      <ul className={classNames(classes.list, classes.text)}>
        <li>Proceed to the next page to view the 5 steps</li>
      </ul>
    </>
  );
};

export default AcquisitionPage04;
